import api, { RequestWithParams, requestParams } from "@src/api/api";
import { BookmarkType } from "@src/types/BookmarkType";

type BookmarksParams = {
  page?: number;
  filter?: "bookmarked_by_me" | "followed_by_me" | "";
};

type BookmarksRequest = RequestWithParams<BookmarksParams>;

type BookmarksResponse = {
  data: BookmarkType[];
  current_page: number;
  total_pages: number;
};

export default async function bookmarks(request: BookmarksRequest): Promise<BookmarksResponse> {
  const { data } = await api.get(`/api/v2/posts${requestParams({ page: 1, ...request.params })}`);
  return data;
}
